var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13566_210707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99964 0.175781C4.48624 0.175781 0 4.66166 0 10.1758C0 15.6899 4.48624 20.1758 9.99964 20.1758C15.5141 20.1758 19.9996 15.6899 19.9996 10.1758C19.9996 4.66166 15.5141 0.175781 9.99964 0.175781ZM9.99964 18.8425C5.22095 18.8425 1.33326 14.9548 1.33326 10.1758C1.33326 5.39673 5.22131 1.50904 9.99964 1.50904C14.779 1.50904 18.6664 5.39673 18.6664 10.1758C18.6664 14.9548 14.7794 18.8425 9.99964 18.8425Z",
    fill: "#7F858E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9542 9.45081H10.6685V3.784C10.6685 3.41574 10.3699 3.11719 10.002 3.11719C9.63449 3.11719 9.33594 3.4161 9.33594 3.784V10.7837H14.9542C15.3221 10.7837 15.6207 10.4855 15.6203 10.1173C15.6203 9.74937 15.3214 9.45081 14.9542 9.45081Z",
    fill: "#7F858E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13566_210707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.175781)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.ea10c00b17b0cf960739957477560aa3.svg";
export { ForwardRef as ReactComponent };